import { Card, Col, Row, Space } from "antd";
import React from "react";
import styled from "styled-components";
import Text from "../Text/Text";
import { numberFormatter } from "../../utility/Formatter";
import { useRecoilValue } from "recoil";
import { sidebarWidthState } from "../../store/sidebarWidthState";

interface Props {
  count: number;
  specialReward: boolean;
  img: string;
  badgeImg: string;
  mileStoneName: string;
  targetAmount: string;
  rewardName: string;
  unlockMainRewardNum?: { num: string | number; name: string } | null;
}

const CardStyled = styled(Card)`
  border-radius: 12px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  overflow: hidden;

  .ant-card-body {
    padding: 0 !important;
  }
`;

function CardRewardTour({
  specialReward,
  img,
  badgeImg,
  mileStoneName,
  targetAmount,
  rewardName,
  unlockMainRewardNum,
  count,
}: Props) {
  const info = [
    {
      label: !specialReward ? `ระดับที่ ${count}` : `รางวัลพิเศษ ${count}`,
      value: mileStoneName || "-",
      labelSize: 12,
      valueSize: 20,
    },
    !specialReward
      ? {
          label: "เป้าหมาย",
          value: `${numberFormatter(targetAmount, 0)} บาท`,
          labelSize: 12,
          valueSize: 14,
        }
      : {
          label: (
            <Row justify='space-between'>
              <Col span={24}>
                <Text fontFamily='Sarabun' fontSize={12} color='Text3' style={{ lineHeight: 1 }}>
                  เป้าหมาย
                </Text>
              </Col>
              {unlockMainRewardNum && (
                <Col
                  span={10}
                  style={{
                    position: "absolute",
                    right: 3,
                    height: 40,
                    width: "100%",
                  }}
                >
                  <Text fontFamily='Sarabun' fontSize={12} color='Text3' style={{ lineHeight: 1 }}>
                    เงื่อนไขผ่านระดับ
                  </Text>
                </Col>
              )}
            </Row>
          ),
          value: (
            <Row justify='space-between'>
              <Col span={24}>
                <Text fontFamily='Sarabun' fontSize={14} style={{ lineHeight: 1 }}>
                  {`${numberFormatter(targetAmount, 0)} บาท`}
                </Text>
              </Col>
              {unlockMainRewardNum && (
                <Col
                  span={12}
                  style={{ position: "absolute", right: 10, marginTop: 2, width: "max-content" }}
                >
                  <Text fontFamily='Sarabun' fontSize={14} style={{ lineHeight: 1 }}>
                    ระดับที่ {unlockMainRewardNum.num} : {unlockMainRewardNum.name}
                  </Text>
                </Col>
              )}
            </Row>
          ),
          valueSize: undefined,
        },
    { label: "รางวัล", value: rewardName, labelSize: 12, valueSize: 14 },
  ];

  return (
    <CardStyled style={{ width: "100%", height: "172px" }}>
      <Row gutter={0} style={{ height: "172px" }}>
        <Col span={8}>
          <img
            src={img}
            style={{
              height: "100%",
              width: "100%",
              objectFit: "cover",
              display: "block",
            }}
            alt='main'
          />
        </Col>
        <Col span={16} style={{ padding: 12 }}>
          <Space direction='vertical' size={2} style={{ width: "100%" }} align='start'>
            {info.map((item, index) => (
              <div key={index} style={{ textAlign: "start" }}>
                {typeof item.label === "string" ? (
                  <Text
                    fontFamily='Sarabun'
                    fontSize={item.labelSize as any}
                    color='Text3'
                    style={{ lineHeight: 1 }}
                  >
                    {item.label}
                  </Text>
                ) : (
                  item.label
                )}

                <div>
                  {typeof item.value === "string" ? (
                    <Text
                      fontFamily='Sarabun'
                      fontSize={item.valueSize as any}
                      fontWeight={item.valueSize === 20 ? 700 : undefined}
                      style={{ lineHeight: 1 }}
                    >
                      {item.value}
                    </Text>
                  ) : (
                    item.value
                  )}
                </div>
              </div>
            ))}
          </Space>
        </Col>
      </Row>
      <img
        src={badgeImg}
        alt='badge'
        style={{
          position: "absolute",
          top: 12,
          right: 12,
          height: 40,
          width: 50,
          objectFit: "contain",
        }}
      />
    </CardStyled>
  );
}

export default CardRewardTour;
